import React from 'react';
import { Drawer, DrawerProps, Space } from 'antd';
import styled from 'styled-components';
import { CloseCircleOutlined } from '@ant-design/icons';
import { COLORS } from '../../utils/constants';

interface CustomDrawerProps extends DrawerProps {
  title: string;
  open: boolean;
  onClose: () => void;
  width?: string | number;
  placement?: 'top' | 'right' | 'bottom' | 'left';
  children: React.ReactNode;
}

const CustomDrawer: React.FC<CustomDrawerProps> = ({
  title,
  open,
  onClose,
  width = '70vw',
  placement = 'right',
  children,
  ...restProps
}) => {
  return (
    <StyledDrawer
      title={title}
      placement={placement}
      width={width}
      onClose={onClose}
      open={open}
      styles={{
        header: {
          backgroundColor: COLORS.blue.primary,
          color: COLORS.white.primary,
        },
      }}
      extra={
        <Space>
          <CloseCircleOutlined
            style={{ fontSize: '20px', color: COLORS.white.primary }}
            onClick={onClose}
          />
        </Space>
      }
      closeIcon={null}
      {...restProps}
    >
      {children}
    </StyledDrawer>
  );
};

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 20px 24px;
  }
`;

export { CustomDrawer as Drawer };
